import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  HostListener,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { CmsserviceService } from "../../common-cms-service/cmsservice.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { Title, Meta } from "@angular/platform-browser";
import { Router } from "@angular/router";
declare var $: any;

interface Slide {
  title: string;
  description: string;
  image: string;
  image_mobile?: string;
  button?: string;
  route?: string;
  tag?: string;
}

interface StudentStory {
  name: string;
  photo: string;
  initials: string;
  accent: "navy" | "cyan" | "gold";
  verified: boolean;
  story: string;
  intro: string;
  points: string[];
}

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
  standalone: false,
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>();

  // 🔹 Dynamic banners
  slides: Slide[] = [];

  // 🔹 Shown only while the CMS banner call is loading / returns empty
  fallbackSlides: Slide[] = [
    {
      title:
        "Master Your GCSEs: Expert Tutoring For <span>AQA, Edexcel &amp; OCR</span>",
      description:
        "Tailored online lessons in Maths, English, and Sciences led by elite UK tutors. Boost grades and build exam confidence.",
      image:
        "https://res.cloudinary.com/dlddixhyu/image/upload/v1768075855/2150256499_yg6l6v.jpg",
      button: "See More",
      route: "/",
    },
  ];

  // 🔹 Hero coverflow slider state
  @ViewChild("cfTrack") cfTrackRef: ElementRef;
  heroActiveIndex = 0;
  heroAutoplayId: any = null;
  heroAutoplayPaused = false;
  heroReducedMotion = false;
  heroScrollTicking = false;

  // 🔹 Other data
  title = "Sehyog";
  siteSetting: any;
  images: any;
  currentSlide = 0;
  slideInterval: any;

  @ViewChild("scTrack") scTrackRef: ElementRef;
  scActiveIndex = 0;
  scScrollTicking = false;

  students: StudentStory[] = [
    {
      name: "",
      initials: "AK",
      photo:
        "https://res.cloudinary.com/do7r12azt/image/upload/v1788023466/Testimony-4_r8dm1g.png",
      accent: "navy",
      verified: true,
      intro: "Here's how Sehyog worked for him:",
      story:
        "After a focused 11+ journey with Sehyog Academy, he secured a place at QE Boys. Regular mock exams helped him identify and improve his weak areas, while crash courses, seminars, algebra courses and varied comprehension practice built his skills and confidence for the real exam.",
      points: [
        "Secured a Place at QE Boys",
        "Identified and Improved Weak Areas Through Mock Exams",
        "Built Skills and Confidence Through Targeted Courses",
        "Strengthened Comprehension With Varied Exam Practice",
      ],
    },
    {
      name: "",
      initials: "PM",
      photo:
        "https://res.cloudinary.com/do7r12azt/image/upload/v1788023464/Student_Testimony_2_akq464.png",
      accent: "gold",
      verified: true,
      intro: "Here's how Sehyog worked for him:",
      story:
        "Regular reading helped build vocabulary, comprehension and writing skills, while Sehyog Academy’s topic tests highlighted weak areas and focused revision. CSSE mock exams then provided valuable experience with challenging, exam-style questions.",
      points: [
        "Built Vocabulary Through Regular Reading",
        "Improved Comprehension and Writing Skills",
        "Identified Weak Areas With Topic Tests",
        "Gained Exam Experience Through CSSE Mocks",
      ],
    },
    {
      name: "",
      initials: "ZR",
      photo:
        "https://res.cloudinary.com/do7r12azt/image/upload/v1788023465/0829_aus99x.png",
      accent: "cyan",
      verified: true,
      intro: "Here's how Sehyog worked for him:",
      story:
        "After dedicated preparation with Sehyog Academy, he secured a place at Queen Elizabeth Boys’ School. Mock exams, detailed feedback, expert advice and crash courses helped him learn from his mistakes and approach the 11+ with greater confidence.",
      points: [
        "Secured a Place at Queen Elizabeth Boys’ School",
        "Learned From Mistakes Through Mock Exams",
        "Built Confidence With Expert Feedback and Advice",
        "Strengthened Preparation Through Crash Courses",
      ],
    },
    {
      name: "",
      initials: "DO",
      photo:
        "https://res.cloudinary.com/do7r12azt/image/upload/v1788023467/0829_1_pl3p5v.png",
      accent: "navy",
      verified: true,
      intro: "Here's how Sehyog worked for her:",
      story:
        "Sehyog’s mock exams gave him a clear understanding of the real 11+ exam, including question types, content and timings. Supportive teachers identified areas where he lacked confidence and helped him strengthen topics beyond what he had covered at school, making him more confident, independent and prepared.",
      points: [
        "Gained Real Exam Experience Through Mock Exams",
        "Identified and Improved Areas Lacking Confidence",
        "Strengthened Topics Beyond School Learning",
        "Became More Confident and Independent",
      ],
    },
  ];

  videos = [
    "https://www.youtube.com/embed/br6vkzqpZHY",
    "https://www.youtube.com/embed/gLnO0THbHTg",
    "https://www.youtube.com/embed/vEFQ9gK0cNY",
    "https://www.youtube.com/embed/Q9O1heDQfHI",
    "https://www.youtube.com/embed/bSFVlZahTac",
  ];

  currentVSlide = 0;
  videosPerView = 3;
  totalSlides = 0;
  dots: number[] = [];

  // 🔹 Popup banners
  popups = [];
  currentPopup: any = null;
  popupTimeout: any = null;

  // 🔹 Gallery section
  gal_images = [
    {
      src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769013030/2023_020_022_1_qguvff.jpg",
      title: "Award Ceremony",
    },
    {
      src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769012652/2023_020_034_ospqt0.jpg",
      title: "Award Ceremony",
    },
    {
      src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769013030/2023_020_040_1_kmobkn.jpg",
      title: "Award Ceremony",
    },
    {
      src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769013030/2023_020_086_1_pgnkwj.jpg",
      title: "Award Ceremony",
    },
    {
      src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769013030/2023_020_072_1_cpezhb.jpg",
      title: "Award Ceremony",
    },
  ];
  isSliding = false;
  currentImageIndex = 0;

  constructor(
    private cmsService: CmsserviceService,
    private router: Router,
    private titleService: Title,
    private meta: Meta,
  ) {
    this.meta.addTags([
      { name: "description", content: "This is 11plus Examination portal" },
      {
        name: "keywords",
        content:
          "gcse revision, gcse maths, gcse past papers, gcse science, gcse maths past papers, gcse revision websites, science gcse online, english gcse revision, mathematics gcse, science and maths tutor, online maths test, english language gcse revision, edexcel gcse maths, 11 plus exam papers, 11 plus tuition, 11 plus tutor, 11 plus tutors near me, 11 plus mock exams, 11 plus mock test, 11 plus papers, 11 plus test papers, eleven plus tuition, eleven plus mock exams, eleven plus papers, eleven plus tutors, 11 plus exam tuition, eleven plus exam papers, 11 plus exam tutors, 11 plus exam mock test, eleven plus test papers, eleven plus mock test, eleven plus verbal reasoning",
      },
    ]);
  }

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.loadHomeBanner();

    this.cmsService.commonSiteSettingSingleton().subscribe((res) => {
      this.siteSetting = res;
    });

    this.upcomingTest();
    this.schedulePopup();
    $(".loader-bg").fadeIn();
    this.calculateView();
  }

  ngAfterViewInit() {
    var self = this;
    this.heroReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    // Wait a tick so *ngFor has rendered the cards before measuring them
    setTimeout(function () {
      self.updateHeroScales();
      self.startHeroAutoplay();
      self.updateStudentScales();
    }, 0);
  }

  // Announcement ticker
  tickerVisible = true;

  /** Fetch banners dynamically from backend */
  loadHomeBanner() {
    this.cmsService
      .homeBanner()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {
          if (res && Array.isArray(res.data)) {
            this.slides = res.data.map((banner: any) => {
              let description = banner.description || "";
              let route = "/";

              const linkMatch = description.match(
                /link\s*=\s*(https?:\/\/[^\s"<]+)/i,
              );
              if (linkMatch && linkMatch[1]) {
                route = linkMatch[1];
                description = description.replace(linkMatch[0], "").trim();
              }

              return {
                title: banner.title || "",
                description,
                image: banner.image || "",
                button: "See More",
                route,
              } as Slide;
            });

            console.log("✅ Banners with extracted routes:", this.slides);

            // Re-measure hero cards once real slides replace the fallback
            var self = this;
            setTimeout(function () {
              self.heroActiveIndex = 0;
              self.updateHeroScales();
            }, 0);
          } else {
            console.warn("No banner data found:", res);
          }
        },
        error: (err) => {
          console.error("Error fetching home banners:", err);
        },
      });
  }

  /** Slides actually rendered in the hero — falls back to a default while CMS data loads */
  get heroSlides(): Slide[] {
    return this.slides && this.slides.length > 0
      ? this.slides
      : this.fallbackSlides;
  }

  onHeroScroll() {
    var self = this;
    if (this.heroScrollTicking) {
      return;
    }
    this.heroScrollTicking = true;
    window.requestAnimationFrame(function () {
      self.updateHeroScales();
      self.heroScrollTicking = false;
    });
  }

  updateHeroScales() {
    if (!this.cfTrackRef) {
      return;
    }
    var track = this.cfTrackRef.nativeElement;
    var cards = track.querySelectorAll(".sh-cf-card");
    if (!cards || cards.length === 0) {
      return;
    }

    var trackRect = track.getBoundingClientRect();
    var trackCenter = trackRect.left + trackRect.width / 2;
    var closestIndex = 0;
    var closestDist = Infinity;

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var rect = card.getBoundingClientRect();
      var cardCenter = rect.left + rect.width / 2;
      var dist = Math.abs(cardCenter - trackCenter);
      var normalized = Math.min(dist / (trackRect.width / 2), 1);
      var scale = 1 - normalized * 0.12;
      var opacity = 1 - normalized * 0.6;

      card.style.transform = "scale(" + scale.toFixed(3) + ")";
      card.style.opacity = opacity.toFixed(3);

      if (dist < closestDist) {
        closestDist = dist;
        closestIndex = i;
      }
    }

    if (closestIndex !== this.heroActiveIndex) {
      this.heroActiveIndex = closestIndex;
    }
  }

  scrollToHeroIndex(i: number) {
    if (!this.cfTrackRef) {
      return;
    }
    var track = this.cfTrackRef.nativeElement;
    var cards = track.querySelectorAll(".sh-cf-card");
    var len = cards.length;
    if (len === 0) {
      return;
    }
    var target = Math.max(0, Math.min(i, len - 1));
    var card = cards[target];
    if (!card) {
      return;
    }

    // Scroll only the track itself (scrollLeft), never scrollIntoView —
    // scrollIntoView can walk up to the page and cause an unwanted vertical jump.
    var trackRect = track.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();
    var delta =
      cardRect.left +
      cardRect.width / 2 -
      (trackRect.left + trackRect.width / 2);
    var targetScrollLeft = track.scrollLeft + delta;

    track.scrollTo({
      left: targetScrollLeft,
      behavior: this.heroReducedMotion ? "auto" : "smooth",
    });
  }

  heroPrev() {
    this.scrollToHeroIndex(this.heroActiveIndex - 1);
  }
  heroNext() {
    this.scrollToHeroIndex(this.heroActiveIndex + 1);
  }
  goToHeroDot(i: number) {
    this.scrollToHeroIndex(i);
  }

  startHeroAutoplay() {
    var self = this;
    this.clearHeroAutoplay();
    if (this.heroReducedMotion) {
      return;
    }
    this.heroAutoplayId = setInterval(function () {
      if (self.heroAutoplayPaused) {
        return;
      }
      var total = self.heroSlides.length;
      if (total < 2) {
        return;
      }
      var next = (self.heroActiveIndex + 1) % total;
      self.scrollToHeroIndex(next);
    }, 5500);
  }

  clearHeroAutoplay() {
    if (this.heroAutoplayId) {
      clearInterval(this.heroAutoplayId);
      this.heroAutoplayId = null;
    }
  }

  pauseHeroAutoplay() {
    this.heroAutoplayPaused = true;
  }

  resumeHeroAutoplay() {
    var self = this;
    setTimeout(function () {
      self.heroAutoplayPaused = false;
    }, 600);
  }

  onSlideButtonClick(index: number) {
    const slide = this.heroSlides[index];
    if (slide && slide.route) {
      if (slide.route.startsWith("http")) {
        window.open(slide.route, "_blank");
      } else {
        this.router.navigate([slide.route]);
      }
    }
  }

  /** Upcoming Session listing (existing logic) */
  upcomingTest() {
    this.cmsService
      .upcomingEventsRecord()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        this.images = res.data;
      });
  }

  /** Gallery Methods */
  get currentImage() {
    return this.gal_images[this.currentImageIndex].src;
  }

  get currentTitle() {
    return this.gal_images[this.currentImageIndex].title;
  }

  changeImage(index: number) {
    if (index !== this.currentImageIndex) {
      this.isSliding = true;
      setTimeout(() => {
        this.currentImageIndex = index;
        this.isSliding = false;
      }, 300);
    }
  }

  /** WhatsApp Join */
  openWhatsApp() {
    window.open("https://chat.whatsapp.com/Epp2q0yma2r0YMa2VC0BPl", "_blank");
  }

  /** Popup Scheduling */
  schedulePopup() {
    this.popupTimeout = setTimeout(() => this.showRandomPopup(), 25000);
  }

  showRandomPopup() {
    const idx = Math.floor(Math.random() * this.popups.length);
    this.currentPopup = this.popups[idx];
  }

  closePopup() {
    this.currentPopup = null;
    this.schedulePopup();
  }

  bookSlot(): void {
    window.location.href =
      "https://www.sehyog.co.uk/11plus-help-club/category/workshop/5a96224a84937ec99f53ef8055c4b81d";
  }

  openQuestionBank(): void {
    window.location.href =
      "https://www.sehyog.co.uk/11plus-help-club/category/offers";
  }

  scrollToMain() {
    const mainElement = document.getElementById("sliderContainer");
    if (mainElement) mainElement.scrollIntoView({ behavior: "smooth" });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    if (this.popupTimeout) clearTimeout(this.popupTimeout);
    this.clearHeroAutoplay();
  }

  get transformStyle(): string {
    const slideWidth = 100 / this.videosPerView;
    const offset = -this.currentVSlide * slideWidth * this.videosPerView;
    return `translateX(${offset}%)`;
  }

  slideVideo(direction: number) {
    this.currentVSlide += direction;
    this.currentVSlide = Math.max(
      0,
      Math.min(this.currentVSlide, this.totalSlides - 1),
    );
  }

  goToSlide(index: number) {
    this.currentVSlide = index;
  }

  calculateView() {
    const width = window.innerWidth;
    this.videosPerView = width <= 640 ? 1 : width <= 992 ? 2 : 3;
    this.totalSlides = Math.ceil(this.videos.length / this.videosPerView);
    this.dots = Array(this.totalSlides).fill(0);
    this.updateHeroScales();
  }

  @HostListener("window:resize")
  onResize() {
    this.calculateView();
  }

  get activeStudent(): StudentStory {
    return this.students[this.scActiveIndex] || this.students[0];
  }

  onScScroll() {
    var self = this;
    if (this.scScrollTicking) {
      return;
    }
    this.scScrollTicking = true;
    window.requestAnimationFrame(function () {
      self.updateStudentScales();
      self.scScrollTicking = false;
    });
  }

  updateStudentScales() {
    if (!this.scTrackRef) {
      return;
    }
    var track = this.scTrackRef.nativeElement;
    var slides = track.querySelectorAll(".sh-sc-slide");
    if (!slides || slides.length === 0) {
      return;
    }

    var trackRect = track.getBoundingClientRect();
    var trackCenter = trackRect.left + trackRect.width / 2;
    var closestIndex = 0;
    var closestDist = Infinity;

    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var rect = slide.getBoundingClientRect();
      var slideCenter = rect.left + rect.width / 2;
      var dist = Math.abs(slideCenter - trackCenter);
      var normalized = Math.min(dist / (trackRect.width / 2), 1);
      var scale = 1 - normalized * 0.22;
      var opacity = 1 - normalized * 0.55;

      slide.style.transform = "scale(" + scale.toFixed(3) + ")";
      slide.style.opacity = opacity.toFixed(3);

      if (dist < closestDist) {
        closestDist = dist;
        closestIndex = i;
      }
    }

    if (closestIndex !== this.scActiveIndex) {
      this.scActiveIndex = closestIndex;
    }
  }

  scrollToStudentIndex(i: number) {
    if (!this.scTrackRef) {
      return;
    }
    var track = this.scTrackRef.nativeElement;
    var slides = track.querySelectorAll(".sh-sc-slide");
    var len = slides.length;
    if (len === 0) {
      return;
    }
    var target = Math.max(0, Math.min(i, len - 1));
    var slide = slides[target];
    if (!slide) {
      return;
    }

    var trackRect = track.getBoundingClientRect();
    var slideRect = slide.getBoundingClientRect();
    var delta =
      slideRect.left +
      slideRect.width / 2 -
      (trackRect.left + trackRect.width / 2);
    var targetScrollLeft = track.scrollLeft + delta;

    track.scrollTo({
      left: targetScrollLeft,
      behavior: this.heroReducedMotion ? "auto" : "smooth",
    });
  }

  scPrev() {
    this.scrollToStudentIndex(this.scActiveIndex - 1);
  }
  scNext() {
    this.scrollToStudentIndex(this.scActiveIndex + 1);
  }
  goToScDot(i: number) {
    this.scrollToStudentIndex(i);
  }
}
